import React from 'react';
import {useBCMSRegistry, disableClickContent} from "../BCMSRegistry/main.jsx";

// Use for declaring parts of page that can be managed by the BCMSRegistry of a PAGE:
export default function BCMSWidget(props) {
  const { state, isActive } = useBCMSRegistry();
  return isActive ? disableClickContent(props.children, state) : props.children;
}
